export default __webpack_public_path__ + "static/media/irrigation_timing_dusk_dawn.de46f2d1.jpg";